import { USER_USERNAME_ERR_MSG_LENGTH } from 'constants/validMsg.js';
import { USER_USERNAME_ERR_MSG_SYMBOL } from 'constants/validMsg.js';
import { USER_USERNAME_ERR_MSG_SPACE } from 'constants/validMsg.js';

/**
 * @param {string} value
 * @returns {Object} result - error message with boolean type.
 */
const validateUsername = (value) => {
	let result = { isErr: false, errMsg: '' };

	if (value.length === 0) {
		result = { isErr: false, errMsg: '' };
		return result;
	} else if (value.length < 8 || value.length > 100) {
		result = { isErr: true, errMsg: USER_USERNAME_ERR_MSG_LENGTH };
		return result;
	} else if (value.length > 8 || value.length < 100) {
		const symbolCount = (value.match(/[',!$%^&*()+|~=`{}[\]:";<>?/]/g) || []).length;
		const spaceCount = (value.match(/[\s]/g) || []).length;

		if (symbolCount > 0) {
			result = { isErr: true, errMsg: USER_USERNAME_ERR_MSG_SYMBOL };
			return result;
		} else if (spaceCount > 0) {
			result = { isErr: true, errMsg: USER_USERNAME_ERR_MSG_SPACE };
			return result;
		} else {
			return result;
		}
	}
};

export default validateUsername;
